import React from 'react'

import { Typography } from '~/components/elements/Typography'
import { VStack } from '~/components/elements/VStack'

export type IndividualTableChartContainerProps = React.PropsWithChildren<{
  id: string
  label: string
}>

export const IndividualTableChartContainer = ({
  children,
  id,
  label,
}: IndividualTableChartContainerProps) => (
  <VStack align="start" id={`individual-table-${id}`} spacing={1}>
    <Typography fontWeight={700} lineHeight={2.5} variant="normal">
      {label}
    </Typography>

    {children}
  </VStack>
)
